import React from 'react';
import { ConfirmModal } from '../../utils/ConfirmModal';
import { capitalizeFirstLetter } from '../../utils/StringHelper';
import {
  ACTIVATE,
  ACTIVATE_ORGANISATION_CONFIRMATION,
  CONFIRM_ACTIVATION_MESSAGE,
  CONFIRM_DEACTIVATION_MESSAGE,
  DEACTIVATE,
  DEACTIVATE_ORGANISATION_CONFIRMATION,
} from '../../utils/constants';

interface Props {
  isActive: boolean;
  isOpen: boolean;
  modalVisibility: (val: boolean) => void;
  onYesClick?(e: any): void;
}

const StatusUpdateConfirmModal = ({
  isActive,
  isOpen,
  modalVisibility,
  onYesClick,
}: Props) => {
  const title = isActive
    ? CONFIRM_DEACTIVATION_MESSAGE
    : CONFIRM_ACTIVATION_MESSAGE;

  const status = isActive ? DEACTIVATE : ACTIVATE;
  const message = isActive
    ? DEACTIVATE_ORGANISATION_CONFIRMATION
    : ACTIVATE_ORGANISATION_CONFIRMATION;

  return (
    <ConfirmModal
      open={isOpen}
      modalVisibility={modalVisibility}
      heading={title}
      message={message}
      onYesClick={onYesClick}
      yesButtonText={capitalizeFirstLetter(status)}
      noButtonText="Cancel"
    />
  );
};

export default StatusUpdateConfirmModal;
